import Icon from '@/components/Icons'
import { useState } from 'react'
import { Wrapper } from '@/components/widgets/blog/CopyLink.styles'

const CopyLink: React.FC = () => {
  const [linkCopied, setLinkCopied] = useState(false)
  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href)
    setLinkCopied(true)
  }

  return (
    <Wrapper linkCopied={linkCopied} onClick={() => copyLink()}>
      <Icon name="link" width={48} height={48} />
    </Wrapper>
  )
}

export default CopyLink
